function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#31978C"
    },
    d: "M120,80h272c13.3,0,24,10.7,24,24v344c0,13.3-10.7,24-24,24H120c-13.3,0-24-10.7-24-24V104C96,90.7,106.7,80,120,80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136,112h240c4.4,0,8,3.6,8,8v312c0,4.4-3.6,8-8,8H136c-4.4,0-8-3.6-8-8V120C128,115.6,131.6,112,136,112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EA69B"
    },
    d: "M304,64h-16c0-17.7-14.3-32-32-32s-32,14.3-32,32h-16c-8.8,0-16,7.2-16,16v16c0,8.8,7.2,16,16,16h96c8.8,0,16-7.2,16-16V80C320,71.2,312.8,64,304,64z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#44C4A1"
    },
    cx: 256,
    cy: 64,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 144,
    style: {
      fill: "#3EA69B"
    },
    width: 176,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 168,
    style: {
      fill: "#44C4A1",
      opacity: 0.6
    },
    width: 136,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 296,
    style: {
      fill: "#44C4A1"
    },
    width: 40,
    height: 96,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 240,
    style: {
      fill: "#F6C358"
    },
    width: 40,
    height: 152,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 200,
    style: {
      fill: "#3EA69B"
    },
    width: 40,
    height: 192,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 296,
    style: {
      fill: "#31978C",
      opacity: 0.3
    },
    width: 40,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 240,
    style: {
      fill: "#DC8744",
      opacity: 0.3
    },
    width: 40,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 200,
    style: {
      fill: "#31978C",
      opacity: 0.3
    },
    width: 40,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DC8744"
    },
    points: "340,160 352,180 346,180 346,192 334,192 334,180 328,180",
    transform: "translate(0,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 80)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCD462"
    },
    points: "0,-20 32,0 0,20 -32,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "0,-20 32,0 0,0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 0,
    style: {
      fill: "#DC8744"
    },
    width: 4,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M-16,6v14c0,6,7,11,16,11s16-5,16-11V6L0,16L-16,6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC8744",
      opacity: 0.15
    },
    d: "M0,6L-16,6v14c0,6,7,11,16,11V6z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DC8744"
    },
    cx: 2,
    cy: 28,
    r: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportEducation);
export default __webpack_public_path__ + "static/media/report-education.4b5059ca73782008487359d644e832ac.svg";
export { ForwardRef as ReactComponent };